export default "__VITE_ASSET__CiHdpaH4__"